// Custos Gerais por Projeto (Gestão Orçamentária): mesmas categorias de Custos Gerais
// (OPERAÇÃO), reorganizadas por projeto. Viagens e Softwares não são mais seções à parte —
// viram só um `tipo_lancamento` de item dentro da árvore de categorias.
// Espelha backend/config.py ROLES_CUSTOS_GERAIS_PROJETO — mantenha os dois em sincronia.
export const ROLES_CUSTOS_GERAIS_PROJETO = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO", "OPERACAO", "ASSISTENTEOPERACAO"];

// Únicas categorias com tipos de lançamento além de "valor_manual" — espelha
// backend/services/custos_gerais_projeto_svc.py _tipos_permitidos, mantenha em sincronia.
export const CODIGO_CATEGORIA_VIAGENS_PREFIXO = "2.5";
export const CODIGO_CATEGORIA_ASSINATURAS = "2.6.11";

// As 4 subcategorias de Viagens com ticket médio travado por projeto (só admin edita, ver
// getTicketsViagemProjeto/putTicketViagemProjeto) — "2.5.05 Verba de Relacionamento" fica de
// fora de propósito, continua um item comum (valor_manual/alocação/qtde usuários). Espelha
// backend/services/custos_gerais_projeto_svc.py CODIGOS_SUBCATEGORIAS_VIAGEM_TICKET.
export const CODIGOS_SUBCATEGORIAS_VIAGEM_TICKET = ["2.5.01", "2.5.02", "2.5.03", "2.5.04"];

// Dentre as 4 acima, só Alimentação e Hospedagem escalam com o nº de dias da viagem — Passagem
// Aérea e Transporte são um custo por viagem (ida/volta), não por dia. Espelha backend
// CODIGOS_SUBCATEGORIAS_VIAGEM_DIAS, mantenha em sincronia.
export const CODIGOS_SUBCATEGORIAS_VIAGEM_DIAS = ["2.5.01", "2.5.02"];

// Única subcategoria de viagem opcional: nem toda viagem depende de passagem aérea (ex.:
// deslocamento terrestre) — ver checkbox "Incluir Passagem Aérea" no ModalGrupoViagem. Espelha
// backend CODIGO_CATEGORIA_PASSAGEM_AEREA.
export const CODIGO_CATEGORIA_PASSAGEM_AEREA = "2.5.03";

// "2.5.05 Verba de Relacionamento" — fora do ticket médio travado (valor manual/discricionário),
// mas pode opcionalmente ser lançada junto do grupo "Lançar Viagem" (checkbox "Incluir Verba de
// Relacionamento" no ModalGrupoViagem/ModalGrupoViagemDespesa). Espelha backend
// CODIGO_CATEGORIA_VERBA_RELACIONAMENTO.
export const CODIGO_CATEGORIA_VERBA_RELACIONAMENTO = "2.5.05";

// "Lançar Kit Admissão" (2.7 Equipamentos e Materiais) — atalho que cria de uma vez 1 Headset + 1
// Teclado + 1 Mouse + 1 Notebook + 1 Monitor (do perfil/opção escolhido), usando o ticket já
// cadastrado em Premissas · Equipamentos e Materiais. Ao contrário de Viagem, 2.7.01–04 continuam
// aceitando lançamento manual normal — o kit é só um atalho a mais, não substitui a lista. Espelha
// backend custos_gerais_projeto_svc.py CODIGO_CATEGORIA_EQUIPAMENTOS_PREFIXO/CODIGO_SUBCATEGORIA_KIT_ADMISSAO.
export const CODIGO_CATEGORIA_EQUIPAMENTOS_PREFIXO = "2.7";
export const CODIGO_SUBCATEGORIA_KIT_ADMISSAO = "2.7.01";
// Equipamentos e Materiais deixou de ser rateável por projeto (decisão do usuário, 2026-09-18):
// todo lançamento de 2.7.x sempre cai no projeto "Rateio Operações" (backend força isso mesmo
// que dados.projeto_id venha diferente — ver custos_gerais_projeto_svc.NOME_PROJETO_RATEIO_OPERACOES).
// Por isso a categoria 2.7 só aparece como lançável no accordion desse projeto específico.
export const NOME_PROJETO_RATEIO_OPERACOES = "Rateio Operações";
// Um "tipo_kit" por perfil/opção de notebook do catálogo (2026-09-22) — "Perfil Operação /
// Desenvolvedores" tem 2 opções de configuração (i5/i7), por isso 2 chaves. Espelha backend
// custos_gerais_projeto_svc.py ITENS_KIT_ADMISSAO_VARIAVEIS, mantenha os dois em sincronia.
export const KIT_ADMISSAO_LABELS = {
  atendimento: "Perfil Atendimento / Uso Geral",
  administrativo: "Perfil Administrativo",
  operacao_i5: "Perfil Operação / Desenvolvedores — Opção 1",
  operacao_i7: "Perfil Operação / Desenvolvedores — Opção 2",
  geoprocessamento: "Perfil Geoprocessamento",
};
// Espelha backend ITENS_KIT_ADMISSAO_COMUNS/ITENS_KIT_ADMISSAO_VARIAVEIS — usado na estimativa
// ao vivo do modal (soma os tickets de Premissas · Equipamentos e Materiais).
export const ITENS_KIT_ADMISSAO_COMUNS = ["HEADSET", "TECLADO", "MOUSE"];
export const ITENS_KIT_ADMISSAO_VARIAVEIS = {
  atendimento: ["NOTEBOOK_ATENDIMENTO", "MONITOR"],
  administrativo: ["NOTEBOOK_ADMINISTRATIVO", "MONITOR"],
  operacao_i5: ["NOTEBOOK_OPERACAO_I5", "MONITOR"],
  operacao_i7: ["NOTEBOOK_OPERACAO_I7", "MONITOR"],
  geoprocessamento: ["NOTEBOOK_GEOPROCESSAMENTO", "MONITOR"],
};
// Reverso de ITENS_KIT_ADMISSAO_VARIAVEIS (código do notebook → tipo_kit) — usado para inferir o
// perfil de um kit já lançado ao reabrir para edição (ver abrirEdicaoItem em
// CustosGeraisProjetoView.js e abrirItemOuGrupo em GestaoOrcamentariaView.js), em vez de um
// if/else binário hardcoded que não escala para mais de 2 perfis.
export const TIPO_KIT_POR_NOTEBOOK_CODIGO = Object.fromEntries(
  Object.entries(ITENS_KIT_ADMISSAO_VARIAVEIS).map(([tipoKit, codigos]) => [
    codigos.find((codigo) => codigo.startsWith("NOTEBOOK_")),
    tipoKit,
  ])
);

export const TIPOS_LANCAMENTO_OPTIONS = [
  { value: "valor_manual", label: "Valor bruto (manual)", descricao: "Só o valor, digitado direto — ex: uma assinatura fixa." },
  { value: "alocacao_projeto", label: "Alocação por Projeto", descricao: "Ticket por pessoa × headcount alocado a este projeto no mês (Σ % de Alocação de Pessoal ÷ 100). Ex.: 2 pessoas a 50% = 1 pessoa equivalente." },
  { value: "quantidade_usuarios", label: "Quantidade de usuários", descricao: "Valor unitário × nº de usuários, preenchido manualmente." },
];

// tipos permitidos por categoria — mesma regra do backend: valor_manual sempre vale; os demais
// só em 2.5 Despesas de Viagens ou 2.6.11 Assinaturas e Sistemas. "viagem" não está mais aqui —
// não é mais selecionável item a item; é criado em grupo (as 4 subcategorias de uma vez, usando
// o ticket travado do projeto) pelo botão "Lançar Viagem" da árvore de Custos Gerais por Projeto.
export function tiposPermitidosParaCategoria(categoria) {
  if (!categoria) return ["valor_manual"];
  if (categoria.codigo === CODIGO_CATEGORIA_ASSINATURAS) return ["valor_manual", "alocacao_projeto", "quantidade_usuarios"];
  if (categoria.codigo === CODIGO_CATEGORIA_VIAGENS_PREFIXO || categoria.codigo.startsWith(`${CODIGO_CATEGORIA_VIAGENS_PREFIXO}.`)) {
    return ["valor_manual", "alocacao_projeto", "quantidade_usuarios"];
  }
  return ["valor_manual"];
}

export function categoriaEhEspecial(categoria) {
  return tiposPermitidosParaCategoria(categoria).length > 1;
}
